/**
 * To avoid merge conflicts, please add new feature flags to a random location (not the last line).
 */
enum featureFlags {
  DEMO_PAGE_DATAGRID_V4 = 'demo-page-datagrid-v4',
  IAM_LOGIN = 'iam_login',
  BC_SOURCE = 'bc_source',
  TRADE_IN = 'trade_in',
  USER_INVITATION = 'core_user_invitation',
  DASHBOARD_CUSTOMISATION = 'dashboard_customisation',
  COPY_INVITATION_LINK = 'copy_invitation_link',
  CAMPAIGNS = 'campaigns',
  SALES_TEST_DRIVE_CALENDAR = 'sales_test_drive_calendar',
  AI_VEHICLE_SERVICE_INTERVALS = 'ai_service_intervals',
  AI_LEAD_MANAGEMENT = 'core_ai_lead_management',
  NEW_VEHICLE_CATALOGUE = 'new_vehicle_catalogue',
  CORE_TELEPHONY = 'core_telephony',
  AFTS_CHECKOUT_SETTINGS = 'afts_checkout_settings',
  RENTAL_VEHICLE_BLOCKS = 'rental_vehicle_blocks',
  AI_LEAD_LOG = 'core_ai_lead_log',
  AI_PRETTIFY = 'ai_prettify',
  AI_LEAD_AUTOMATED_COMMUNICATION = 'core_ai_lead_automated_communication',
  MY_PROFILE_AVATAR = 'avatar_in_my_profile',
  SALES_360_VEHICLES = 'vehicle_360_view_datagrid',
  OS_BUSINESS_CASES = 'businesscases_360_view_datagrid',
  RETRY_INTERCEPTOR = 'retry_interceptor',
  AUTH_PROFILE_SELECTOR = 'auth_profile_selector',
  ADVERTISEMENT_VGP_PROMPT_BRIDGE = 'advertisement_vgp_prompt_bridge',
  SALES_CEBIA_REPORT_CLASSIFIED_PUBLISHING_SWITCH = 'sales_cebia_report_classified_publishing_switch',
  SALES_CEBIA_SMART_CODE_URL_PUBLISHING_SWITCH = 'sales_cebia_smart_code_url_publishing_switch',
  SALES_CENTRALIZED_PRICING = 'sales_buying_pricer_role',
  SALES_FEATURE_SCORING = 'acl_sales_feature_scoring',
  SALES_FEATURE_SUBCATEGORIES = 'sales_feature_subcategories',
  ADVANCED_MECHANICS_LABOUR_ITEMS_REPORTING = 'advanced_mechanics_labour_items_reporting',
  CRM_SALES_ACTIVITIES = 'crm_sales_activities',
  USER_LOGIN_HISTORY = 'user_login_history',
  SALES_BGR_BANNER = 'sales_bgr_banner',
  SALES_LEAGUE = 'sales_league',
  BUSINESS_CASE_SERIES_DEFINITION_CREATION_DISABLED = 'business_case_series_definition_creation_disabled',
  ORCHESTRATION_MODULE = 'orchestration_module',
  BUYING_ONLINE_OFFER = 'buying_online_offer',
  MAGIC_BUTTON = 'magic_button',
  AI_EMAIL_GENERATOR = 'ai_email_generator',
  GLOBAL_SEARCH = 'global_search',
  OMNETIC_AI_ASSISTANT = 'omnetic_ai_assistant',
  VEHICLE_MILEAGE_HISTORY = 'vehicle_mileage_history',
  CORE_CHECKLIST_AUDITS = 'core_checklist_audits',
  CUSTOM_NOTICES = 'custom_notices',
  CORE_NEWS_POPUP = 'core_news_popup',
  CORE_TEAMS = 'core_teams',
  CORE_BRANCH_OPENING_TIMES = 'core_branch_opening_times',
  SALES_CUSTOM_MAKE_MODEL = 'sales_custom_make_model',
  ACCOUNTING_ADDITIONAL_CUSTOMER = 'sales_accounting_additional_customer',
  ADVERTISEMENT_VERSION_GENERATION_ATTRIBUTES = 'sales_ads_version_generation_attributes',
  ADVERTISEMENT_RICH_TEXT_DESCRIPTION = 'sales_ads_rich_text_description',
  ADVERTISEMENT_PREFLIGHT = 'advertisment_preflight',
  ADVERTISEMENT_MULTILANGUAGE_CONTENT = 'advertisement_multilanguage_content',
  ADVERTISEMENT_PER_PLATFORM_ATTRIBUTES = 'sales_ads_per_platform_attributes',
  AUTOSTACJA_CUSTOMER_WIDGET = 'autostacja_customer_widget',
  SETTINGS_FACEBOOK = 'settings_facebook',
  OUTLOOK_INTEGRATION = 'outlook_integration',
  WHATSAPP_INTEGRATION = 'whatsapp_integration',
  WHATSAPP_MANUAL_CONFIGURATION = 'whatsapp_manual_configuration',
  WHATSAPP_EMBEDDED_SIGNUP = 'whatsapp_embedded_signup',
  SETTINGS_JBR = 'settings_jbr',
  CUPRA_BACKGROUND = 'background_cupra',
  SETTINGS_TWO_FACTOR_AUTH = 'core_settings_two_factor',
  OAUTH_CLIENTS_MANAGEMENT = 'oauth_clients_management',
  NOTIFICATIONS_COMMENT_MENTION = 'notifications_comment_mention',
  INTEREST_CLONE_FLOW = 'interest_clone_flow',
  SUPPLIER_CATALOG_IMPORT = 'supplier_catalog_import',
  AFS_WAREHOUSE_EXPERIMENTAL_EXTRACT_NISSAN_DIGLAS_INVOICE = 'afs_warehouse_experimental_extract_nissan_diglas_invoice',
  INTEREST_CUSTOM_FIELDS = 'interest_custom_fields',
  CUSTOMER_PRIMARY_CONTACT = 'customer_primary_contant',
  INTEREST_RECOMMENDATIONS = 'interest_recommendations',
  DATA_GRID_BULK_OPERATIONS = 'data_grid_bulk_operations',
  EMPLOYEE_CUSTOM_FIELDS = 'employee_custom_fields',
  EMPLOYEE_MANAGEMENT = 'employee_management',
  SIDEBAR_REMOVE_QUICK_ACTIONS = 'sidebar_remove_quick_actions',
  VEHICLE_WAREHOUSE = 'vehicle_warehouse',
  REPLACE_VEHICLE_DG_WITH_OPENSEARCH = 'replace_vehicle_dg_with_opensearch',
  SALES_INSURANCE_COMPARISON_V1 = 'sales_insurance_comparison_v1',
  AFS_WORKSHOP_EXPERIMENTAL_SUPPLIER_CATALOG_SEARCH = 'afs_workshop_experimental_supplier_catalog_search',
  SALES_TEST_DRIVES_V2 = 'sales_testdrives_v2',
  SALES_SALE_PROGRAMS = 'sales_sale_programs',
  QUALITY_SEAL = 'quality_seal',
  SALES_WARRANTY = 'sales_warranty',
  FINANCING_PROMO_PHOTOS = 'financing_promo_photos',
  COMPOSITION_EDITOR = 'composition_editor',
  VEHICLE_FINANCING = 'vehicle_financing',
  MY_PROFILE = 'my_profile',
  QUICK_PURCHASE = 'quick_purchase',
  USER_ABSENCE = 'user_absence',
  REMOVE_VEHICLE_FROM_SALE = 'remove_vehicle_from_sale',
  SALE_INTEREST_ACTION_LOG = 'sale_interest_action_log',
  SALES_ACTION_LOG_CUSTOMER = 'sales_action_log_customer',
  VERSION_LOG_DUMP = 'version_log_dump',
  VEHICLE_HEADER_V3 = 'vehicle_header_v3',
  SALES_VGP_CERTIFICATES = 'sales_vgp_certificates',
  EMPLOYEE_AVATARS = 'core_employee_avatars',
  CORE_GDPR_DATAGRID = 'core_gdpr_datagrid',
  VEHICLE_THREE_HUNDRED_AND_SIXTY_PHOTOS = 'vehicle_three_hundred_and_sixty_photos',
  SALES_FAST_BUYING = 'sales_fast_buying',
  SALES_FAST_PRICING = 'sales_fast_pricing',
  SALES_FINANCING_ENDING = 'sales_financing_ending',
  SCRIPT_BEAMER = 'script_beamer',
  SERVICE_CASE_COLLAPSIBLE_HEADER = 'service_case_collapsible_header',
  SCRIPT_CLARITY = 'script_clarity',
  CKK_CONSENT_STATUS_FLOW = 'ckk_consent_status_flow',
  SETTINGS_WATERMARKS_CATEGORIES = 'settings_watermarks_categories',
  SALES_VEHICLE_WAREHOUSE_SALESINFO = 'sales_vehicle_warehouse_salesinfo',
  SALES_SALE_VEHICLE_COMMENTS = 'sales_comments_for_sale_vehicle',
  SETTINGS_ADVERTISEMENT_MULTIBRANCH = 'settings_advertisement_multibranch',
  SETTINGS_ADVERTISEMENT_AUTOMATIC_UPDATE = 'settings_advertisement_automatic_update',
  INTEREST_CUSTOMER_INQUIRY = 'interest_customer_inquiry',
  SALES_VEHICLE_DAT_DECODER = 'sales_vehicle_dat_decoder',
  AFS_WAREHOUSE_TRANSFER_ORDER = 'afs_warehouse_transfer_order',
  ACL_VAT_CALCULATION_DEFINITION = 'acl_vat_calculation_definition',
  ADVANCED_WAREHOUSE_INVENTORY_VALUE_REPORTING = 'advanced_warehouse_inventory_value_reporting',
  ADVANCED_WAREHOUSE_DEAD_STOCK_REPORTING = 'advanced_warehouse_dead_stock_reporting',
  ADVANCED_WAREHOUSE_MOVEMENTS_REPORTING = 'advanced_warehouse_movements_reporting',
  ADVANCED_WAREHOUSE_DIRECT_SALES_REPORTING = 'advanced_warehouse_direct_sales_reporting',
  AFTERSALES_REPORTING_CHART_LAYOUT = 'aftersales_reporting_chart_layout',
  DG_SHARED_PRESETS = 'dg_shared_presets_',
  ACL_VAT_CHECK_DEFINITION = 'acl_vat_check_definition',
  ACL_NEGATIVE_DOCUMENT_CANCELLATION_DEFINITION = 'acl_negative_document_cancellation_definition',
  ADVERTISEMENT_FAKE_PLATFORMS = 'advertisement_fake_platforms',
  ADVERTISEMENT_NEW_PLATFORMS = 'advertisement_new_platforms',
  ADVERTISEMENT_AUTOMARKETPL = 'advertisement_automarketpl',
  ADVERTISEMENT_FACEBOOK = 'advertisement_facebook',
  ADVERTISEMENT_MERCEDES_NA_SKLADE_REST = 'advertisement_mercedes_na_sklade_rest',
  ADVERTISEMENT_OTOMOTO_PROMPT_BRIDGE = 'advertisement_otomoto_prompt_bridge',
  ADVERTISEMENT_AUTOCARIS_PROMPT_BRIDGE = 'advertisement_autocaris_prompt_bridge',
  ADVERTISEMENT_MERCEDES_NA_SKLADE_PROMPT_BRIDGE = 'advertisement_mercedes_na_sklade_prompt_bridge',
  ADVERTISEMENT_HYUNDAI_PROMISE_PROMPT_BRIDGE = 'advertisement_hyundai_promise_prompt_bridge',
  ADVERTISEMENT_MOBILE_DE_PROMPT_BRIDGE = 'advertisement_mobile_de_prompt_bridge',
  ADVERTISEMENT_SAMOCHODY_PL = 'advertisement_samochody_pl',
  INSPECTION_TO_REVISION_NO_EDIT = 'inspection_to_revision_no_edit',
  INTERESTS_UTM = 'interests_utm',
  SALE_VEHICLE_OPENSEARCH = 'sale_vehicle_opensearch',
  MESSAGE_TEMPLATES = 'message_templates',
  DOCUMENT_TEMPLATE_EDITOR = 'document_template_editor',
  MESSAGE_EMAIL_REDESIGN_AFTERSALES = 'message_email_redesign_aftersales',
  MESSAGE_SYNCHRONIZATION = 'message_synchronization',
  MERCEDES_BACKGROUND_PHOTOS = 'mercedes_background_photos',
  MERCEDES_BACKGROUND_ZIZAK = 'mercedes_background_zizak',
  MERCEDES_BACKGROUND_VSP = 'mercedes_background_vsp',
  MERCEDES_BACKGROUND_SW = 'mercedes_background_s&w',
  DAVOCAR_BACKGROUND = 'background_davocar',
  DAT_VIN_DECODER = 'dat_vin_decoder',
  VSP_BACKGROUND = 'background_vsp',
  ACL_DOCUMENTS = 'acl_documents',
  SALES_SELLER_AS_SUPPLIER = 'sales_seller_as_supplier',
  OMNETIC_VIN_DECODER = 'omnetic_vin_decoder',
  SALES_BR_CUSTOM_LICENSE_PLATE = 'sales_br_custom_license_plate',
  CORE_MULTI_LANGUAGE_SUPPORT = 'core_multi_language_support',
  CORE_DIGISIGN_BANNER = 'core_digisign_banner',
  CORE_AI_DESCRIPTION_BANNER = 'core_ai_description_banner',
  SALE_TASKS_CHECKLIST = 'sale_tasks_checklist',
  SALES_COSTS_WITH_VAT = 'sales_costs_with_vat',
  SALES_PURCHASE_PRICE = 'sales_purchase_price',
  IMPORT_MODULE = 'import_module',
  KONZULTA_SMS = 'konzulta_sms',
  CAR_VERTICAL_INTEGRATION = 'car_vertical_integration',
  MIRA_PREDICTIVE_MAINTENANCE = 'mira_predictive_maintenance',
  VEHICLE_PREMIUM_FEATURES = 'vehicle_premium_features',
  WORKSHOP_INTEREST = 'workshop_interest',
  AFS_WAREHOUSE_ARTICLE_UPDATE_JOB = 'afs_warehouse_article_update_job',
  AFS_WAREHOUSE_ACL_SCOPES = 'afs_warehouse_acl_scopes',
  AFS_WAREHOUSE_FAST_TRACK_ISSUE = 'warehouse_fast_track_issue',
  AFS_WAREHOUSE_DELIVERY_NOTE_DOCUMENT_PREVIEW = 'afs_warehouse_delivery_note_document_preview',
  AFS_WAREHOUSE_EXTRACT_DELIVERY_NOTE = 'afs_warehouse_extract_delivery_note',
  OFFER_VALIDITY = 'offer_validity',
  ONLINE_OFFER_DISCLAIMER = 'online_offer_disclaimer',
  ONLINE_OFFER_SETTINGS = 'online_offer_settings',
  SOURCING_SUSPICIOUS_VEHICLES = 'sourcing_suspicious_vehicles',
  SOURCING_HITLIST_BLACKLIST = 'sourcing_hitlist_blacklist',
  SOURCING_AVAILABILITY_CHECK = 'sourcing_availability_check',
  SOURCING_ATTRACTIVENESS_SCORE = 'sourcing_attractiveness_score',
  SOURCING_VAN_FILTERS = 'sourcing_van_filters',
  DASHBOARD_FAST_PRICING_BUTTON = 'dashboard_fast_pricing_button',
  SOURCING_PRICE_CHANGES = 'sourcing_price_changes',
  SOURCING_UNIFIED_SURFACES = 'sourcing_unified_surfaces',
  SOURCING_RESIZABLE_PREVIEW = 'sourcing_resizable_preview',
  SOURCING_REAL_TIME_ADVERTISEMENT = 'sourcing_real_time_advertisement',
  SOURCING_CLASSIFIEDS_MAP = 'sourcing_classifieds_map',
  SOURCING_CARVAGO_BUY = 'sourcing_carvago_buy',
  SOURCING_SAVED_FILTERS = 'sourcing_saved_filters',
  SOURCING_FILTER_POSITION = 'sourcing_filter_position',
  SOURCING_COLLAPSIBLE_FILTER_HEADER = 'sourcing_collapsible_filter_header',
  EAG_GRID_EXPERIMENTAL_EXTERNAL_BULK_ACTIONS = 'eag_grid_experimental_external_bulk_actions',
  SCHEDULED_MESSAGES = 'scheduled_messages',
  ADVERTISEMENT_VGP = 'advertisement_vgp',
  ADVERTISEMENT_AUDI_PL = 'advertisement_audi_pl',
  SOURCING_AUCTIONS = 'sourcing_auctions',
  SOURCING_NL_BPM = 'sourcing_nl_bpm',
  SOURCING_ORIGIN_COUNTRY_FILTER = 'sourcing_origin_country_filter',
  SOURCING_INTERIOR_MATERIAL_FILTER = 'sourcing_interior_material_filter',
  SOURCING_VEHICLE_PREVIEW_REDESIGN = 'sourcing_vehicle_preview_redesign',
  EAG_GRID_EXPERIMENTAL_COLUMNS_PANEL_SCROLL_TO = 'eag_grid_experimental_columns_panel_scroll_to',
  EAG_GRID_EXPERIMENTAL_DRAWER_MODE = 'eag_grid_experimental_drawer_mode',
  EAG_GRID_EXPERIMENTAL_FILTER_BY_VALUE = 'eag_grid_experimental_filter_by_value',
}

// eslint-disable-next-line import/no-default-export
export default featureFlags;
export {featureFlags};

/**
 * To avoid merge conflicts, please add new feature flags to a random location (not the last line).
 */
